import { render, staticRenderFns } from "./vueedit.vue?vue&type=template&id=2533e300&scoped=true"
import script from "./vueedit.vue?vue&type=script&lang=js"
export * from "./vueedit.vue?vue&type=script&lang=js"
import style0 from "./vueedit.vue?vue&type=style&index=0&id=2533e300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533e300",
  null
  
)

export default component.exports